import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicHeader from './components/PublicHeader';
import SidebarDashboard from './components/PublicSidebar';
import './PublicJobLayout.scss';

const PublicJobLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const basePath = pathParts.slice(0, 2).join("-");

  // Ensure sidebar is collapsed on every page navigation
  useEffect(() => {
    try {
      localStorage.setItem('dashCollapsed', 'true');
    } catch (e) {
      // Handle localStorage errors silently
    }
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className={`front main-content public-job-layout ${basePath}`}>
      <div className='user-container'>
        <SidebarDashboard
          mobileMenuOpen={mobileMenuOpen}
          closeMobileMenu={closeMobileMenu}
          isPublicPage={true}
        />
        <main className="center-content">
          <PublicHeader
            toggleMobileMenu={toggleMobileMenu}
            mobileMenuOpen={mobileMenuOpen}
          />
          <div className='inner-content'>
            <Outlet />
          </div>
        </main>
      </div>
      {/* Mobile menu overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
    </div>
  );
};

export default PublicJobLayout;
